import { getAzureUserInformation } from '@/auth/azure/azureManager'
import DashboardPage from './DashboardPage'
import { RoleRoute, RouteFunctionParams } from '@/types'
import { defer, LoaderFunction } from 'react-router-typesafe'
import { useQsAdminApiManager } from '@/auth/api/qsadminapiManager'
import { Roles } from '@/auth/azure/Roles'
import RouterErrorHandler from '@/components/RouterErrorHandler'
import { Card } from '@/routes/home/card/Card.enums'

export const dashboardPageRouterLoader = (async ({ request, params }: RouteFunctionParams) => {
  const qsAdminApi = useQsAdminApiManager.getState().service
  let dashboardNormalView: boolean = true
  let dashboardCards: string[] = [
    Card.NextCommitmentsCard,
    Card.ReminderCard,
    Card.FromYourAccountCard,
    Card.ActivitiesSummaryCard,
  ]
  const dashboardCardsLocalStorage = localStorage.getItem(`dashboard-cards`)
  if (
    dashboardCardsLocalStorage !== undefined &&
    dashboardCardsLocalStorage !== null &&
    dashboardCardsLocalStorage !== ''
  )
    dashboardCards = JSON.parse(dashboardCardsLocalStorage) satisfies string[]

  const dashboardNormalViewLocalStorage = localStorage.getItem(`dashboard-normal-view`)
  if (
    dashboardNormalViewLocalStorage !== undefined &&
    dashboardNormalViewLocalStorage !== null &&
    dashboardNormalViewLocalStorage !== ''
  )
    dashboardNormalView = dashboardNormalViewLocalStorage === 'true' ? true : false

  try {
    const userInfo = await getAzureUserInformation()
    const getCurrentEmployee = qsAdminApi.user().query((builder, impiegato) => {
      builder.filter(impiegato.email.eq(userInfo?.email ?? ''))
      builder.select('id', 'fullname', 'email')
    })
    return defer({
      userInfo,
      getCurrentEmployee,
      dashboardCards,
      dashboardNormalView,
    })
  } catch (error) {
    console.log(`Auth Error: ${error}`)
    return {
      userInfo: undefined,
      getCurrentEmployee: undefined,
      dashboardCards,
      dashboardNormalView,
    }
  }
}) satisfies LoaderFunction

const DashboardPageRoute: RoleRoute = {
  path: 'dashboard',
  loader: dashboardPageRouterLoader,
  element: <DashboardPage />,
  errorElement: <RouterErrorHandler />,
  text: 'Dashboard',
  icon: 'datapie',
  mainMenuRoute: true,
  allowedRoles: [Roles.Guest],
}

export default DashboardPageRoute
